/* tslint:disable */
/* eslint-disable */
/**
 * Water Bureau Admin Portal - Debug API
 * Debug APIs for development and testing purposes. These APIs bypass authentication and should only be enabled in development environments.
 *
 * The version of the OpenAPI document: debug-1.0.0
 * Contact: debug@waterbureau.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface MeterInfoBrandRequest
 */
export interface MeterInfoBrandRequest {
    /**
     * 
     * @type {string}
     * @memberof MeterInfoBrandRequest
     */
    'scope': MeterInfoBrandRequestScopeEnum;
    /**
     * 
     * @type {string}
     * @memberof MeterInfoBrandRequest
     */
    'councilCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof MeterInfoBrandRequest
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof MeterInfoBrandRequest
     */
    'name'?: string;
}

export const MeterInfoBrandRequestScopeEnum = {
    Global: 'GLOBAL',
    Council: 'COUNCIL'
} as const;

export type MeterInfoBrandRequestScopeEnum = typeof MeterInfoBrandRequestScopeEnum[keyof typeof MeterInfoBrandRequestScopeEnum];


